import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Card, CardBody, Collapse } from "reactstrap";

const propTypes = {
  appName: PropTypes.string
};

const FAQS = appName => [
  {
    question: `What is ${appName}?`,
    answer: `${appName} provides professional digital advertising to local real estate agents and home sellers with powerful, easy-to-use technology.`
  },
  {
    question: "How does it work?",
    answer: `${appName} ads show up on Facebook and top sites all around the web. The ads target viewers who have recently visited real estate websites and searched for a new home in your area.`
  },
  {
    question: `Who uses ${appName}?`,
    answer: `${appName} is used daily by smart real estate professionals who want an easy and effective way to advertise their listings and provide top-notch service to their clients.`
  }
];

const ClientLandingFaq = ({ appName = "Adwerx" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const faqs = FAQS(appName);

  return (
    <Card className="client-landing-faq my-3">
      <CardBody className="px-3 py-2">
        <div className="client-landing-faq__header">
          <span className="client-landing-faq__icon icon-badge d-inline-flex">
            <i className="fa fa-question" aria-hidden="true" />
          </span>
          <div className="client-landing-faq__heading">
            <div className="client-landing-faq__title">Frequently Asked Questions</div>
            <div className="text-muted font-size-small">
              Learn more about how {appName} works for you
            </div>
          </div>
          <Button
            color="link"
            className="client-landing-faq__toggle text-decoration-none"
            onClick={() => setIsOpen(!isOpen)}
            aria-expanded={isOpen}
            aria-controls="client-landing-faq-content"
          >
            {isOpen ? "HIDE" : "SHOW"}
            <i className={`fa fa-angle-${isOpen ? "up" : "down"} ml-2`} aria-hidden="true" />
          </Button>
        </div>
        <Collapse isOpen={isOpen} unmountOnExit>
          <div className="client-landing-faq__list mt-3" id="client-landing-faq-content">
            {faqs.map(faq => (
              <div className="client-landing-faq__item" key={faq.question}>
                <dt>{faq.question}</dt>
                <dd>{faq.answer}</dd>
              </div>
            ))}
          </div>
        </Collapse>
      </CardBody>
    </Card>
  );
};

ClientLandingFaq.propTypes = propTypes;

export default ClientLandingFaq;
